// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useEffect} from 'react';
import {Hero} from '../../ui/location/hero';
import {use_pathname} from '../../../../hola/pub/lib/use_pathname';
import country from '/util/country.js';
import {bd_countries} from 'hola_opt';
import {t_country_object} from '../../types';
import {Why_oculus} from '../../ui/homepage/why_oculus';
import {Use_cases} from '../../ui/homepage/use_cases';
import {Products} from '../../ui/homepage/products';
import {Reviews} from '../../ui/homepage/reviews';
import {prepare_continent_data}
    from '../../../../toolip/pub/pages/toolip.io/proxy-location';
import {Top_locations} from '../../ui/common/top_locations';
import {HP_faq} from '../../ui/homepage/faq';
import {use_scroll_to_top} from '../../ui/common/use_scroll_to_top';
import {perr_www_visit} from 'hola_pub_util';

const continents = ['europe', 'north-america', 'latin-america', 'asia',
    'africa', 'oceania'];

const is_continent = name=>continents.includes(name.toLowerCase());

const find_country_by_name = (name: string): t_country_object | null=>{
    const normalized_name = name.replace(/-/g, ' ').toUpperCase().trim();
    const c = Object.entries(country.list).find(([, val])=>
        (val as string).toUpperCase() == normalized_name);
    return c ? country.get_country_object(c[0]) : null;
};

const get_continent_key = continent_name=>{
    const continent_mapping = {
        'europe': 'Europe',
        'north america': 'Northern America',
        'latin america': 'LATAM',
        'asia': 'Asia',
        'africa': 'Africa',
        'oceania': 'Oceania'
    };
    return continent_mapping[continent_name.toLowerCase()] ||
        continent_name.replace(/\b\w/g, c=>c.toUpperCase());
};

export const Root = ()=>{
    const {set, params} = use_pathname();
    useEffect(()=>{
        perr_www_visit({id: 'oculus_proxy_location_visit'});
    }, []);
    use_scroll_to_top();
    const location_name = params['proxy-location'];
    const us_region_name = params['united-states'];
    useEffect(()=>{
        if (location_name?.length == 2)
        {
            const c = Object.entries(country.list).find(([key])=>
                key == location_name.toUpperCase());
            if (c && typeof c[1] == 'string')
            {
                set({
                    'proxy-location': c[1].replace(/\s+/g, '-').toLowerCase()
                });
            }
        }
    }, [location_name, set]);
    const detected_location_name = !location_name &&
        us_region_name ? 'united-states' : location_name;
    const mode = !detected_location_name ? 'landing' :
        is_continent(detected_location_name) ? 'continent' : 'country';
    const not_landing = mode != 'landing';
    let data = null;
    if (mode=='continent')
    {
        const continent_name = detected_location_name.replace(/-/g, ' ');
        const continent_key = get_continent_key(continent_name);
        const ip_count = bd_countries.by_region[continent_key]?.count || 0;
        data = {
            name: continent_name.replace(/\b\w/g, l=>l.toUpperCase()),
            ip_count: ip_count
        };
    }
    else if (mode=='country')
    {
        const country_obj = find_country_by_name(detected_location_name);
        if (!country_obj)
            return <div>Invalid Location</div>;
        country_obj.code = country_obj.code == 'uk' ? 'gb' : country_obj.code;
        const ip_count = bd_countries && bd_countries[country_obj.code] || 0;
        data = {
            name: us_region_name ? us_region_name.replace(/\b\w/g, l=>l.toUpperCase())
            : country_obj.name,
            ip_count: ip_count,
            country_code: country_obj.code
        };
    }
    return <div>
      <Hero mode={mode} data={data}/>
      {mode != 'country' &&
        <Top_locations mode={mode} continent_name={detected_location_name}/>}
      <Why_oculus/>
      <Use_cases/>
      <Products/>
      {not_landing && <Reviews/>}
      {not_landing && <HP_faq/>}
      {!not_landing && <HP_faq title={'Our Global Proxies'}
        get_questions={prepare_continent_data}/>}
    </div>;
};

const meta = {
    meta: props=>{
        const param = props?.params?.['proxy-location'] || '';
        let title, description, canonical_url;
        if (!param)
        {
            title = 'Proxy IP Servers in Any Location | Oculus';
            description = 'Find proxies in any location.';
            canonical_url = 'https://oculusproxies.com/proxy-location/';
        }
        else
        {
            const country_name = param.replace(/-/g, ' ')
                .replace(/\b\w/g, c=>c.toUpperCase());
            title = `${country_name} Proxies | Oculus`;
            description = `Try ${country_name} proxies with a free trial. `;
            canonical_url = `https://oculusproxies.com/proxy-location/${param}`;
        }
        return {title, description, canonical_url};
    },
    no_ssr: false,
    ssr_force: true,
};

Root.meta = meta;
